import { createRootRoute } from '@tanstack/react-router';

import NotFoundView from 'features/not-found/NotFoundView';
import { AppCrashNotification } from 'root/AppCrashNotification';

import { RootLayout } from './RootLayout';

export const rootRoute = createRootRoute({
  component: RootLayout,
  notFoundComponent: NotFoundView,
  errorComponent: ({ error }) => <AppCrashNotification message={error.message} />,
});
